import { render, staticRenderFns } from "./hotArea.edit.vue?vue&type=template&id=2df4fc8c&scoped=true"
import script from "./hotArea.edit.vue?vue&type=script&lang=js"
export * from "./hotArea.edit.vue?vue&type=script&lang=js"
import style0 from "./hotArea.edit.vue?vue&type=style&index=0&id=2df4fc8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4fc8c",
  null
  
)

export default component.exports